import React from 'react';
import './speaker.scss';
import Img from 'gatsby-image';

interface Props {
  speakerName: string;
  description: string;
  linkedInURL?: string;
  twitterURL: string;
  profileImage: any;
}

const Speaker: React.FC<Props> = ({ speakerName, description, twitterURL, profileImage }) => {
  return (
    <div className="speakerContainer">
      {profileImage && <Img className="imageForEventSpeakers" fluid={profileImage} />}
      <div className="speakerContainerInner">
        <div className="speakerContainerInnerTextContainer">
          <h5 onClick={() => window.open(twitterURL, '_blank')}>{speakerName}</h5>
        </div>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Speaker;
